// Highchart
import Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";

import "assets/styles/components/highcharts.css";

// Material Compoents
import { Box } from "@mui/material";

// Components
import { ChartErrorModal } from "components/Charts/components/ChartErrorModal";
import CustomiseLabels from "components/Charts/components/CustomiseLabelsLegacy";

// Hooks
import useDomain from "./useDomain";

// Types
import { IBaseChartProps } from "components/Charts/chart.types";

HC_more(Highcharts);

const Domain = ({ width, height, getData, hideRefSeries, moreOptions }: IBaseChartProps): JSX.Element => {
    const {
        chartOptions,
        chartData,
        chartRef,
        containerRef,
        showNoDataModal,
        showNames,
        showRoles,
        setShowNames,
        setShowRoles,
        onCloseNoDataModal,
    } = useDomain({
        width,
        height,
        getData,
        hideRefSeries,
    });

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
                width: "100%",
                height: "100%",
                margin: "auto",
                position: "relative",
            }}
            ref={containerRef}
        >
            {chartData && <HighchartsReact highcharts={Highcharts} options={chartOptions} ref={chartRef} />}
            <ChartErrorModal open={showNoDataModal} onClose={onCloseNoDataModal} containerRef={containerRef} />
            {!moreOptions?.hideCustomizeLabels && (
                <CustomiseLabels
                    setShowRoles={setShowRoles}
                    showRoles={showRoles}
                    showNames={showNames}
                    setShowNames={setShowNames}
                />
            )}
        </Box>
    );
};

export default Domain;
